import { useState, useEffect } from 'react';
import { Grid3X3,Database, Layers, ShoppingBag, ShoppingCart, Globe, Search, ChevronLeft, ChevronRight  } from 'lucide-react';
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import {getLicensorDataExploerView,getDataExplorerDetails,getDataExplorerPortfolio,getDataExplorerException} from "../../services/admin"
import $ from "jquery";
import { hasPageAccess,accessDenied } from "../../utils/page_access"; // Import
import Multiselect from 'multiselect-react-dropdown';
import HeaderLogo  from "../structure/headerlogo";

/**
 * Exception
 * Data Explorer - Exception view.
 * Displays portfolio and combination explorer UI for exception data,
 * fetches data from admin services, and provides filter / export functionality.
 * Adds modal support to view exception details for combinations.
 */

export const Exception = () => {

    const [tab1, setTab1] = useState({
    portfolioData: [], // Full portfolio
    licensors: [],
    properties: [],
    products: [],
    channels: [],
    territories: [],
    selectedLicensors: [],
    selectedProperties: [],
    selectedProducts: [],
    selectedChannels: [],
    selectedTerritories: []
  });



  let pageName = "Data Explorer";


  // const [combinationSearch, setCombinationSearch] = useState('');
  // const [currentPage, setCurrentPage] = useState(1);
  // const rowsPerPage = 50;

  // --- ADD: modal state & handlers for exceptions ---
  const [showExceptionsModal, setShowExceptionsModal] = useState(false);
  const [modalExceptions, setModalExceptions] = useState('');

  const openExceptionsModal = (exceptions) => {
    // normalize to string for display
    let content = '';
    if (Array.isArray(exceptions)) content = exceptions.join('\n');
    else if (typeof exceptions === 'object' && exceptions !== null) content = JSON.stringify(exceptions, null, 2);
    else content = String(exceptions || '');
    setModalExceptions(content);
    setShowExceptionsModal(true);
  };

  /**
   * closeExceptionsModal
   * Close the exceptions modal and clear its contents.
   */
  const closeExceptionsModal = () => {
    setShowExceptionsModal(false);
    setModalExceptions('');
  };


  const [tab1selectedLicensors, settab1SelectedLicensors] = useState([]);
  const [tab1selectedProperties, settab1SelectedProperties] = useState([]);
  const [tab1selectedChannels, settab1SelectedChannels] = useState([]);
  const [tab1selectedTerritories, settab1SelectedTerritories] = useState([]);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // This will hold the API response
  const [tabportfoliodata, setTabPortFolioData] = useState([]); // This will hold the API response
 const  [tabportfoliolicensordata, setTabPortFolioLicensorData] = useState([]); // This will hold the API response


  const [tableData, setTableData] = useState([]); // State to hold API data
  
  // Options for filters returned by the tableData response
  const [productOptions, setProductOptions] = useState([]);
  const [channelOptions, setChannelOptions] = useState([]);
  const [territoryOptions, setTerritoryOptions] = useState([]);
    
  const [fileName, setFileName] = useState("");
  const [property, setProperty] = useState("");
    
  const [category, setCategory] = useState("");
  const [channel, setChannel] = useState("");
  const [territory, setTerritory] = useState("");

  
  const [view, setView] = useState('combination'); // 'dimension' or 'combination'
  const [step, setStep] = useState(1);
  const [licensors, setLicensors] = useState([]);
  const [properties, setProperties] = useState([]);
  const [products, setProducts] = useState([]);
  const [channels, setChannels] = useState([]);
  const [territories, setTerritories] = useState([]);
  const [combinations, setCombinations] = useState([]);

  const [selectedLicensor, setSelectedLicensor] = useState(null);
  const [selectedProperties, setSelectedProperties] = useState([]);

  const [licensorFilter, setLicensorFilter] = useState('');
  const [propertyFilter, setPropertyFilter] = useState('');
  const [productFilters, setProductFilters] = useState({ l1: '', l2: '', l3: '' });
  const [channelFilters, setChannelFilters] = useState({ l1: '', l2: '', l3: '' });
  const [territoryFilters, setTerritoryFilters] = useState({ l1: '', l2: '' });

  const [combinationFilters, setCombinationFilters] = useState({
    productL1: 'All',
    productL2: 'All',
    productL3: 'All',
    channelL1: 'All',
    channelL2: 'All',
    channelL3: 'All',
    territoryL1: 'All',
    territoryL2: 'All',
  });
  const [combinationSearch, setCombinationSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 50;


    // Handle Licensor selection
    /**
     * handleLicensorSelect
     * Callback for licensor multiselect component.
     * @param {Array} selectedList - Selected licensor items
     */
    const handleLicensorSelect = (selectedList) => {
      settab1SelectedLicensors(selectedList);
    };

  // Handle Product selection
  /**
   * handlePropertiesSelect
   * Callback for properties multiselect component.
   * @param {Array} selectedList - Selected property items
   */
  const handlePropertiesSelect = (selectedList) => {
    settab1SelectedProperties(selectedList);
  };


  // Handle undefined safely
  const licensors_tabportfolio = tabportfoliodata?.licensor || [];
  const productsportfolio = tabportfoliodata?.product || [];

  // useEffect(() => {
  //   console.log("Selected Licensors:", selectedLicensors);
  //   console.log("Selected Products:", selectedProducts);
  // }, [tab1selectedLicensors, selectedProducts]);



  const filteredLicensors = licensors.filter(l =>
    l.name.toLowerCase().includes(licensorFilter.toLowerCase())
  );

  const filteredProperties = properties.filter(p =>
    p.name.toLowerCase().includes(propertyFilter.toLowerCase())
  );

  const uniqueProducts = {
    level1: [...new Set(products.map(p => p.level1))],
    level2: [...new Set(products.map(p => p.level2))],
    level3: [...new Set(products.map(p => p.level3))],
  };

  const uniqueChannels = {
    level1: [...new Set(channels.map(c => c.level1))],
    level2: [...new Set(channels.map(c => c.level2))],
    level3: [...new Set(channels.map(c => c.level3))],
  };

  const uniqueTerritories = {
    level1: [...new Set(territories.map(t => t.level1))],
    level2: [...new Set(territories.map(t => t.level2))],
  };

  const filteredProducts = products.filter(p =>
    p.level1.toLowerCase().includes(productFilters.l1.toLowerCase()) &&
    p.level2.toLowerCase().includes(productFilters.l2.toLowerCase()) &&
    p.level3.toLowerCase().includes(productFilters.l3.toLowerCase())
  );

  const filteredChannels = channels.filter(c =>
    c.level1.toLowerCase().includes(channelFilters.l1.toLowerCase()) &&
    c.level2.toLowerCase().includes(channelFilters.l2.toLowerCase()) &&
    c.level3.toLowerCase().includes(channelFilters.l3.toLowerCase())
  );

  const filteredTerritories = territories.filter(t =>
    t.level1.toLowerCase().includes(territoryFilters.l1.toLowerCase()) &&
    t.level2.toLowerCase().includes(territoryFilters.l2.toLowerCase())
  );

  // Process API data to extract licensors and properties
  /**
   * processApiData
   * Transform raw API response into UI-friendly structures: licensors and properties.
   * @param {Array} apiData - Raw array from API
   * @returns {{processedLicensors: Array, allProperties: Array}}
   */
  const processApiData = (apiData) => {
    const processedLicensors = apiData.map(item => ({
      id: item.label, // Using label as ID since it's unique
      name: item.label,
      property_count: item.propertyType.length
    })).sort((a, b) => a.name.localeCompare(b.name));

    // Extract all properties from all licensors
    const allProperties = [];
    apiData.forEach(licensor => {
      licensor.propertyType.forEach(property => {
        allProperties.push({
          id: `${licensor.label}_${property}`, // Create unique ID
          licensor_id: licensor.label,
          name: property
        });
      });
    });

    return { processedLicensors, allProperties };
  };

  

   
  /**
   * fetchDataTab1
   * Fetch portfolio data for tab1 (portfolio/filters) and populate multiselect options.
   */
  const fetchDataTab1 = async () => {
    $(".page_pro_load").hide();
    setLoading(true);
    try {


let obj = {"licensor":tab1.selectedLicensors,
"propertyType":tab1.selectedProperties,
"productL1":tab1.selectedProductL1,
"productL2":tab1.selectedProductL2,
"productL3":tab1.selectedProductL3,
"channelsL1":tab1.selectedChannelsL1,
"channelsL2":tab1.selectedChannelsL2,
"channelsL3":tab1.selectedChannelsL3,
"territoriesL1":tab1.selectedTerritoryL1,
"territoriesL2":tab1.selectedTerritoryL2
}


      const result = await getDataExplorerPortfolio(obj);
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setTabPortFolioData(result.data);
        
        // Prepare data for multiselect components from API response
        const data = result.data;
        
        // Prepare licensors for multiselect
        const licensorOptions = (data.licensor || []).map((name, index) => ({
          name: name,
          id: `licensor_${index + 1}`
        }));
        
        // Prepare properties for multiselect
        const propertyOptions = (data.Properties || []).map((name, index) => ({
          name: name,
          id: `property_${index + 1}`
        }));
        
        // Prepare product options for multiselect
        const productL1Options = (data.product?.productL1 || []).map((name, index) => ({
          name: name,
          id: `productL1_${index + 1}`
        }));
        
        const productL2Options = (data.product?.productL2 || []).map((name, index) => ({
          name: name,
          id: `productL2_${index + 1}`
        }));
        
        const productL3Options = (data.product?.productL3 || []).map((name, index) => ({
          name: name,
          id: `productL3_${index + 1}`
        }));
        
        // Prepare channel options for multiselect
        const channelL1Options = (data.channels?.channelsL1 || []).map((name, index) => ({
          name: name,
          id: `channelL1_${index + 1}`
        }));
        
        const channelL2Options = (data.channels?.channelsL2 || []).map((name, index) => ({
          name: name,
          id: `channelL2_${index + 1}`
        }));
        
        const channelL3Options = (data.channels?.channelsL3 || []).map((name, index) => ({
          name: name,
          id: `channelL3_${index + 1}`
        }));
        
        // Prepare territory options for multiselect
        const territoryL1Options = (data.territories?.territoriesL1 || []).map((name, index) => ({
          name: name,
          id: `territoryL1_${index + 1}`
        }));
        
        const territoryL2Options = (data.territories?.territoriesL2 || []).map((name, index) => ({
          name: name,
          id: `territoryL2_${index + 1}`
        }));
        
        // Update tab1 state with all the prepared data
        setTab1(prev => ({
          ...prev,
          portfolioData: data,
          licensors: licensorOptions,
          properties: propertyOptions,
          products: productL1Options, // You can combine all product levels or keep separate
          channels: channelL1Options, // You can combine all channel levels or keep separate
          territories: territoryL1Options, // You can combine all territory levels or keep separate
          productL1Options,
          productL2Options,
          productL3Options,
          channelL1Options,
          channelL2Options,
          channelL3Options,
          territoryL1Options,
          territoryL2Options,
          selectedLicensors: [],
          selectedProperties: [],
          selectedProducts: [],
          selectedChannels: [],
          selectedTerritories: []
        }));
        
        setTabPortFolioLicensorData(data.licensor);
      } else {
        console.warn("Unexpected response status:", result.status);
        setTab1(prev => ({ ...prev, portfolioData: [] }));
      }
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      setTab1(prev => ({ ...prev, portfolioData: [] }));
    } finally {
      setLoading(false);
    }

  };



  /**
   * fetchDataTab2
   * Fetch licensor view data and transform it for the dimension explorer.
   */
  const fetchDataTab2 = async () => {
    $(".page_pro_load").hide();
    setLoading(true);
    try {
      const result = await getLicensorDataExploerView();
      if (result.code === API_SUCCESS_RESPONSE_CODE) {
        setData(result.data);
        
        // Process the API data
        const { processedLicensors, allProperties } = processApiData(result.data);
        
        // Set processed data
        setLicensors(processedLicensors);
        setProperties(allProperties);
      } else {
        console.warn("Unexpected response status:", result.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      trackError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataTab2();
    fetchDataTab1();
  }, []);


    // ----------------------------- SELECTION HANDLERS -----------------------------
  /**
   * handleSelect
   * Generic handler to set multiselect values in `tab1` state.
   * @param {string} key - The state key to update (e.g., 'selectedLicensors')
   * @param {Array} selectedList - The selected items
   */
  const handleSelect = (key, selectedList) => {
    setTab1(prev => ({ ...prev, [key]: selectedList }));
    setCurrentPage(1);
    //fetchDataTab1()
  };

  // ----------------------------- PORTFOLIO COMBINATION FILTER -----------------------------
  /**
   * getFilteredPortfolio
   * Apply current tab1 selection filters to the portfolio data.
   * @returns {Array} Filtered portfolio items
   */
  const getFilteredPortfolio = () => {
    const { portfolioData, selectedLicensors, selectedProperties, selectedProducts, selectedChannels, selectedTerritories } = tab1;
    if (!Array.isArray(portfolioData)) return [];
    return portfolioData.filter(item => {
      const licensorMatch = selectedLicensors.length ? selectedLicensors.some(l => l.name === item.licensor) : true;
      const propertyMatch = selectedProperties.length ? selectedProperties.some(p => p.name === item.property) : true;
      const productMatch = selectedProducts.length ? selectedProducts.some(pr => item.products.includes(pr.name)) : true;
      const channelMatch = selectedChannels.length ? selectedChannels.some(ch => item.channels.includes(ch.name)) : true;
      const territoryMatch = selectedTerritories.length ? selectedTerritories.some(t => item.territories.includes(t.name)) : true;
      return licensorMatch && propertyMatch && productMatch && channelMatch && territoryMatch;
    });
  };

    const filteredPortfolio = getFilteredPortfolio();


             /**
            * getDataExplorerDetail
            * Fetch exception data for selected licensor/properties and populate table/filter options.
            * @param {object} data - Request object containing licensor and propertyType
            */
             const getDataExplorerDetail = async (data) => {
               // alert(JSON.stringify(data))
        
               // $(".page_pro_load").hide();
               // setLoading(true); // Stop loading spinner
                try {
                  const result = await getDataExplorerException(data);
                  if (result.code === API_SUCCESS_RESPONSE_CODE) {
                    // store API response object which contains product/channel/territory arrays and 'data' array
                    setTableData(result.data || {});
                    setProductOptions(result.data?.product || []);
                    setChannelOptions(result.data?.channel || []);
                    setTerritoryOptions(result.data?.territory || []);
                  } else {
                    console.warn("Unexpected response status:", result.status);
                  }
                } catch (error) {
                  console.error("Error fetching data:", error);
                }
                finally {
                   setLoading(false); // Stop loading spinner
               }
              };


  // Update the licensorProperties calculation to work with API data
  const licensorProperties = properties.filter(p =>
    selectedLicensor ? p.licensor_id === selectedLicensor.id : false
  );

  /**
   * toggleProperty
   * Toggle a property selection in `selectedProperties`.
   * @param {string} propertyName
   */
  const toggleProperty = (propertyName) => {
    if (selectedProperties.includes(propertyName)) {
      setSelectedProperties(selectedProperties.filter(p => p !== propertyName));
    } else {
      setSelectedProperties([...selectedProperties, propertyName]);
    }
  };

  /**
   * getRelevantCombinations
   * Build combination rows from API table data using current `selectedProperties`.
   * If no API data exists, fall back to static `combinations`.
   * @returns {Array} Array of combination objects
   */
  const getRelevantCombinations = () => {
    // Check if we have tableData from the API
    if (tableData && tableData.data && Array.isArray(tableData.data)) {
      const apiCombinations = [];
      let combinationId = 0;

      // Process each data item from the API response
      tableData.data.forEach((item, itemIndex) => {
        const productL1 = item["Product Category (L1)"] || '';
        const productL2 = item["Product SubCategory (L2)"] || '';
        const channelL1 = item["Channel (L1)"] || '';
        const channelL2 = item["Channel SubType (L2)"] || '';
        const territoryL1 = item["Territory (L1)"] || '';
        const territoryL2 = item["Territory Zone (L2)"] || '';
        
        const productL3Array = item["Product (L3)"] || [];
        const channelL3Array = item["Channel (L3)"] || [];

        // If no Channel (L3) array, create a single entry with empty channel L3
        const channelsToProcess = channelL3Array.length > 0 ? channelL3Array : [''];
          const exceptionsValue = item["exceptions"] || item["exceptions"] || item["exceptions"] || item["exception"] || item["exceptions"] || '';

        // Create combinations for each Product L3 x Channel L3 combination
        productL3Array.forEach(productL3 => {
          channelsToProcess.forEach(channelL3 => {
            // Create combination for each selected property
            selectedProperties.forEach(property => {
              apiCombinations.push({
                id: `api_${combinationId++}`,
                property: property,
                product_l1: productL1,
                product_l2: productL2,
                product_l3: productL3,
                channel_l1: channelL1,
                channel_l2: channelL2,
                channel_l3: channelL3,
                territory_l1: territoryL1,
                territory_l2: territoryL2,
                restrictions: '', // No restrictions data in this API response
                exceptions:exceptionsValue
              });
            });
          });
        });
      });

      return apiCombinations;
    }

    // Fallback to static combinations if no API data
    return combinations.filter(c => 
      selectedProperties.length ? selectedProperties.includes(c.property) : true
    );
  };

  const filteredCombinations = getRelevantCombinations().filter(c => {
    const matchesFilters =
      (combinationFilters.productL1 === 'All' || c.product_l1 === combinationFilters.productL1) &&
      (combinationFilters.productL2 === 'All' || c.product_l2 === combinationFilters.productL2) &&
      (combinationFilters.productL3 === 'All' || c.product_l3 === combinationFilters.productL3) &&
      (combinationFilters.channelL1 === 'All' || c.channel_l1 === combinationFilters.channelL1) &&
      (combinationFilters.channelL2 === 'All' || c.channel_l2 === combinationFilters.channelL2) &&
      (combinationFilters.channelL3 === 'All' || c.channel_l3 === combinationFilters.channelL3) &&
      (combinationFilters.territoryL1 === 'All' || c.territory_l1 === combinationFilters.territoryL1) &&
      (combinationFilters.territoryL2 === 'All' || c.territory_l2 === combinationFilters.territoryL2);

    const matchesSearch = combinationSearch === '' ||
      Object.values(c).some(val =>
        String(val).toLowerCase().includes(combinationSearch.toLowerCase())
      );

    return matchesFilters && matchesSearch;
  });

 

  const totalPages = Math.ceil(filteredCombinations.length / rowsPerPage);
  const paginatedCombinations = filteredCombinations.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const uniqueCombinationValues = {
    productL1: ['All', ...new Set(getRelevantCombinations().map(c => c.product_l1))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    productL2: ['All', ...new Set(getRelevantCombinations().map(c => c.product_l2))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    productL3: ['All', ...new Set(getRelevantCombinations().map(c => c.product_l3))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    channelL1: ['All', ...new Set(getRelevantCombinations().map(c => c.channel_l1))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    channelL2: ['All', ...new Set(getRelevantCombinations().map(c => c.channel_l2))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    channelL3: ['All', ...new Set(getRelevantCombinations().map(c => c.channel_l3))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    territoryL1: ['All', ...new Set(getRelevantCombinations().map(c => c.territory_l1))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
    territoryL2: ['All', ...new Set(getRelevantCombinations().map(c => c.territory_l2))].sort((a, b) => {
      if (a === 'All') return -1;
      if (b === 'All') return 1;
      return a.localeCompare(b);
    }),
  };

  // Add helper functions here
/**
 * getFilteredProductL2Options
 * Compute Product L2 choices constrained by current Product L1 filter.
 * @returns {Array<string>}
 */
const getFilteredProductL2Options = () => {
  if (combinationFilters.productL1 === 'All') {
    return uniqueCombinationValues.productL2;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => c.product_l1 === combinationFilters.productL1)
      .map(c => c.product_l2)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredProductL3Options
 * Compute Product L3 choices constrained by Product L1/L2 filters.
 * @returns {Array<string>}
 */
const getFilteredProductL3Options = () => {
  if (combinationFilters.productL1 === 'All' && combinationFilters.productL2 === 'All') {
    return uniqueCombinationValues.productL3;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => 
        (combinationFilters.productL1 === 'All' || c.product_l1 === combinationFilters.productL1) &&
        (combinationFilters.productL2 === 'All' || c.product_l2 === combinationFilters.productL2)
      )
      .map(c => c.product_l3)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredChannelL2Options
 * Compute Channel L2 choices constrained by current Channel L1 filter.
 * @returns {Array<string>}
 */
const getFilteredChannelL2Options = () => {
  if (combinationFilters.channelL1 === 'All') {
    return uniqueCombinationValues.channelL2;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => c.channel_l1 === combinationFilters.channelL1)
      .map(c => c.channel_l2) // Fixed: was c.channelL2, should be c.channel_l2
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredChannelL3Options
 * Compute Channel L3 choices constrained by current Channel L1/L2 filters.
 * @returns {Array<string>}
 */
const getFilteredChannelL3Options = () => {
  if (combinationFilters.channelL1 === 'All' && combinationFilters.channelL2 === 'All') {
    return uniqueCombinationValues.channelL3;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => 
        (combinationFilters.channelL1 === 'All' || c.channel_l1 === combinationFilters.channelL1) &&
        (combinationFilters.channelL2 === 'All' || c.channel_l2 === combinationFilters.channelL2)
      )
      .map(c => c.channel_l3)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

/**
 * getFilteredTerritoryL2Options
 * Compute Territory L2 choices constrained by current Territory L1 filter.
 * @returns {Array<string>}
 */
const getFilteredTerritoryL2Options = () => {
  if (combinationFilters.territoryL1 === 'All') {
    return uniqueCombinationValues.territoryL2;
  }
  const relevantCombinations = getRelevantCombinations();
  const filteredOptions = ['All', ...new Set(
    relevantCombinations
      .filter(c => c.territory_l1 === combinationFilters.territoryL1)
      .map(c => c.territory_l2)
  )].sort((a, b) => {
    if (a === 'All') return -1;
    if (b === 'All') return 1;
    return a.localeCompare(b);
  });
  return filteredOptions;
};

// Add these handler functions
const handleProductL1Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    productL1: value,
    productL2: 'All', // Reset dependent filters
    productL3: 'All'
  });
  setCurrentPage(1);
};

const handleProductL2Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    productL2: value,
    productL3: 'All' // Reset dependent filter
  });
  setCurrentPage(1);
};

const handleChannelL1Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    channelL1: value,
    channelL2: 'All', // Reset dependent filters
    channelL3: 'All'
  });
  setCurrentPage(1);
};

const handleChannelL2Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    channelL2: value,
    channelL3: 'All' // Reset dependent filter
  });
  setCurrentPage(1);
};

const handleTerritoryL1Change = (value) => {
  setCombinationFilters({
    ...combinationFilters,
    territoryL1: value,
    territoryL2: 'All' // Reset dependent filter
  });
  setCurrentPage(1);
};

/**
 * handleProductL1Change
 * Update product L1 filter and reset dependent product filters.
 * @param {string} value
 */

/**
 * handleProductL2Change
 * Update product L2 filter and reset dependent productL3 filter.
 * @param {string} value
 */

/**
 * handleChannelL1Change
 * Update channel L1 filter and reset dependent channel filters.
 * @param {string} value
 */

/**
 * handleChannelL2Change
 * Update channel L2 filter and reset dependent channelL3 filter.
 * @param {string} value
 */

/**
 * handleTerritoryL1Change
 * Update territory L1 filter and reset dependent territoryL2 filter.
 * @param {string} value
 */


  return (
    <div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">

             <div className="mb-4">
            <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <Grid3X3 size={24} />
              </div>
              <div>
                <h1 className="h3 mb-0 fw-bold">Exception Data Explorer</h1>
                <p className="text-muted mb-0 small">Explore licensing data exception</p>
              </div>
            </div>
          </div>
          { loading ? <PageLoader /> :
      
          hasPageAccess(pageName, "view") === false ? accessDenied() : 
          (
          <>    
          {/* <div className="mb-4 d-none">
            <div className="btn-group" role="group">
              <button
                className={`btn ${view === 'dimension' ? 'btn-primary' : 'btn-outline-primary'} d-flex align-items-center`}
                onClick={() => { setView('dimension'); setStep(1); }}
              >
                <Layers size={16} className="me-2" />
                Portfolio Explorer
              </button>
              <button
                className={`btn ${view === 'combination' ? 'btn-primary' : 'btn-outline-primary'} d-flex align-items-center`}
                onClick={() => { setView('combination'); setStep(1); }}
              >
                <Database size={16} className="me-2" />
                Combination Explorer
              </button>
            </div>
            <small className="text-muted ms-3">
              {view === 'dimension' ? 'View unique values in each dimension independently' : 'Explore all valid combinations with restrictions'}
            </small>
          </div> */}

          {view === 'dimension' && (
  <div className="row g-4">

    {/* Licensors Panel */}
    <div className="col-md-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <Database size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Licensors</h5>
            </div>
            <span className="badge bg-primary rounded-pill">{tab1.selectedLicensors.length}</span>
          </div>
          <Multiselect
            options={tab1.licensors || []}
            selectedValues={tab1.selectedLicensors || []}
            onSelect={(selectedList) => handleSelect('selectedLicensors', selectedList)}
            onRemove={(selectedList) => handleSelect('selectedLicensors', selectedList)}
            displayValue="name"
            placeholder="Filter Licensors"
            showCheckbox
          />
          <div className="small text-muted mt-2 mb-2 fw-semibold">
            {tab1.selectedLicensors.length > 0 ? 'Selected Licensors' : 'All Licensors'}
          </div>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {tab1.selectedLicensors.length > 0 ? (
              // Show selected licensors when filtered
              tab1.selectedLicensors.map((licensor) => (
                <div key={licensor.id} className="border-bottom py-2 small">
                  {licensor.name}
                </div>
              ))
            ) : (
              // Show all licensors by default
              (tab1.licensors || []).map((licensor) => (
                <div key={licensor.id} className="border-bottom py-2 small text-muted">
                  {licensor.name}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Properties Panel */}
    <div className="col-md-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <Layers size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Properties</h5>
            </div>
            <span className="badge bg-primary rounded-pill">{tab1.selectedProperties.length}</span>
          </div>
          <Multiselect
            options={tab1.properties || []}
            selectedValues={tab1.selectedProperties || []}
            onSelect={(selectedList) => handleSelect('selectedProperties', selectedList)}
            onRemove={(selectedList) => handleSelect('selectedProperties', selectedList)}
            displayValue="name"
            placeholder="Filter Properties"
            showCheckbox
          />
          <div className="small text-muted mt-2 mb-2 fw-semibold">
            {tab1.selectedProperties.length > 0 ? 'Selected Properties' : 'All Properties'}
          </div>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {tab1.selectedProperties.length > 0 ? (
              // Show selected properties when filtered
              tab1.selectedProperties.map((property) => (
                <div key={property.id} className="border-bottom py-2 small">
                  
                  {property.name}
                </div>
              ))
            ) : (
              // Show all properties by default
              (tab1.properties || []).map((property) => (
                <div key={property.id} className="border-bottom py-2 small text-muted">
                  {property.name}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Products Panel */}
    <div className="col-md-4">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <ShoppingBag size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Products</h5>
            </div>
            <span className="badge bg-primary rounded-pill">
              {(tab1.selectedProductL1?.length || 0) + (tab1.selectedProductL2?.length || 0) + (tab1.selectedProductL3?.length || 0)}
            </span>
          </div>

          <div className="row g-2 mb-3">
            <div className="col-4">
             
              <Multiselect
                options={tab1.productL1Options || []}
                selectedValues={tab1.selectedProductL1 || []}
                onSelect={(selectedList) => handleSelect('selectedProductL1', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedProductL1', selectedList)}
                displayValue="name"
                placeholder="Product L1"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
            <div className="col-4">
              
              <Multiselect
                options={tab1.productL2Options || []}
                selectedValues={tab1.selectedProductL2 || []}
                onSelect={(selectedList) => handleSelect('selectedProductL2', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedProductL2', selectedList)}
                displayValue="name"
                placeholder="Product L2"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
            <div className="col-4">
           
              <Multiselect
                options={tab1.productL3Options || []}
                selectedValues={tab1.selectedProductL3 || []}
                onSelect={(selectedList) => handleSelect('selectedProductL3', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedProductL3', selectedList)}
                displayValue="name"
                placeholder="Product L3"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
          </div>

          <div className="small text-muted mb-2 fw-semibold">
            {(tab1.selectedProductL1?.length > 0 || tab1.selectedProductL2?.length > 0 || tab1.selectedProductL3?.length > 0) ? 'Selected Products' : 'All Products'}
          </div>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {(tab1.selectedProductL1?.length > 0 || tab1.selectedProductL2?.length > 0 || tab1.selectedProductL3?.length > 0) ? (
              // Show selected products when filtered
              <>
                {tab1.selectedProductL1?.map((product) => (
                  <div key={product.id} className="border-bottom py-1 small">
                    <span className="badge bg-primary me-1">L1</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {product.name}
                  </div>
                ))}
                {tab1.selectedProductL2?.map((product) => (
                  <div key={product.id} className="border-bottom py-1 small">
                    <span className="badge bg-secondary me-1">L2</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {product.name}
                  </div>
                ))}
                {tab1.selectedProductL3?.map((product) => (
                  <div key={product.id} className="border-bottom py-1 small">
                    <span className="badge bg-dark me-1">L3</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {product.name}
                  </div>
                ))}
              </>
            ) : (
              // Show all products by default
              <>
                <div className="small fw-semibold text-primary mb-1">Level 1 Products:</div>
                {(tab1.productL1Options || []).map((product) => (
                  <div key={product.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-primary me-1">L1</span>
                    {product.name}
                  </div>
                ))}
                <div className="small fw-semibold text-secondary mb-1 mt-2">Level 2 Products:</div>
                {(tab1.productL2Options || []).map((product) => (
                  <div key={product.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-secondary me-1">L2</span>
                    {product.name}
                  </div>
                ))}
                <div className="small fw-semibold text-dark mb-1 mt-2">Level 3 Products:</div>
                {(tab1.productL3Options || []).slice(0, 10).map((product) => (
                  <div key={product.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-dark me-1">L3</span>
                    {product.name}
                  </div>
                ))}
                {(tab1.productL3Options || []).length > 10 && (
                  <div className="text-muted small py-1">
                    ... and {(tab1.productL3Options || []).length - 10} more items
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Channels Panel */}
    <div className="col-md-6">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <ShoppingCart size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Channels</h5>
            </div>
            <span className="badge bg-primary rounded-pill">
              {(tab1.selectedChannelL1?.length || 0) + (tab1.selectedChannelL2?.length || 0) + (tab1.selectedChannelL3?.length || 0)}
            </span>
          </div>

          <div className="row g-2 mb-3">
            <div className="col-4">
             
              <Multiselect
                options={tab1.channelL1Options || []}
                selectedValues={tab1.selectedChannelL1 || []}
                onSelect={(selectedList) => handleSelect('selectedChannelL1', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedChannelL1', selectedList)}
                displayValue="name"
                placeholder="Channel L1"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
            <div className="col-4">
             
              <Multiselect
                options={tab1.channelL2Options || []}
                selectedValues={tab1.selectedChannelL2 || []}
                onSelect={(selectedList) => handleSelect('selectedChannelL2', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedChannelL2', selectedList)}
                displayValue="name"
                placeholder="Channel L2"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
            <div className="col-4">
              
              <Multiselect
                options={tab1.channelL3Options || []}
                selectedValues={tab1.selectedChannelL3 || []}
                onSelect={(selectedList) => handleSelect('selectedChannelL3', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedChannelL3', selectedList)}
                displayValue="name"
                placeholder="Channel L3"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
          </div>

          <div className="small text-muted mb-2 fw-semibold">
            {(tab1.selectedChannelL1?.length > 0 || tab1.selectedChannelL2?.length > 0 || tab1.selectedChannelL3?.length > 0) ? 'Selected Channels' : 'All Channels'}
          </div>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {(tab1.selectedChannelL1?.length > 0 || tab1.selectedChannelL2?.length > 0 || tab1.selectedChannelL3?.length > 0) ? (
              // Show selected channels when filtered
              <>
                {tab1.selectedChannelL1?.map((channel) => (
                  <div key={channel.id} className="border-bottom py-1 small">
                    <span className="badge bg-primary me-1">L1</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {channel.name}
                  </div>
                ))}
                {tab1.selectedChannelL2?.map((channel) => (
                  <div key={channel.id} className="border-bottom py-1 small">
                    <span className="badge bg-secondary me-1">L2</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {channel.name}
                  </div>
                ))}
                {tab1.selectedChannelL3?.map((channel) => (
                  <div key={channel.id} className="border-bottom py-1 small">
                    <span className="badge bg-dark me-1">L3</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {channel.name}
                  </div>
                ))}
              </>
            ) : (
              // Show all channels by default
              <>
                <div className="small fw-semibold text-primary mb-1">Level 1 Channels:</div>
                {(tab1.channelL1Options || []).map((channel) => (
                  <div key={channel.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-primary me-1">L1</span>
                    {channel.name}
                  </div>
                ))}
                <div className="small fw-semibold text-secondary mb-1 mt-2">Level 2 Channels:</div>
                {(tab1.channelL2Options || []).map((channel) => (
                  <div key={channel.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-secondary me-1">L2</span>
                    {channel.name}
                  </div>
                ))}
                <div className="small fw-semibold text-dark mb-1 mt-2">Level 3 Channels:</div>
                {(tab1.channelL3Options || []).map((channel) => (
                  <div key={channel.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-dark me-1">L3</span>
                    {channel.name}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Territories Panel */}
    <div className="col-md-6">
      <div className="card h-100 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center">
              <Globe size={20} className="text-primary me-2" />
              <h5 className="mb-0 fw-bold">Territories</h5>
            </div>
            <span className="badge bg-primary rounded-pill">
              {(tab1.selectedTerritoryL1?.length || 0) + (tab1.selectedTerritoryL2?.length || 0)}
            </span>
          </div>

          <div className="row g-2 mb-3">
            <div className="col-6">
            
              <Multiselect
                options={tab1.territoryL1Options || []}
                selectedValues={tab1.selectedTerritoryL1 || []}
                onSelect={(selectedList) => handleSelect('selectedTerritoryL1', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedTerritoryL1', selectedList)}
                displayValue="name"
                placeholder="Territory L1"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
            <div className="col-6">
             
              <Multiselect
                options={tab1.territoryL2Options || []}
                selectedValues={tab1.selectedTerritoryL2 || []}
                onSelect={(selectedList) => handleSelect('selectedTerritoryL2', selectedList)}
                onRemove={(selectedList) => handleSelect('selectedTerritoryL2', selectedList)}
                displayValue="name"
                placeholder="Territory L2"
                showCheckbox
                style={{
                  chips: { background: 'rgba(137, 101, 240, 0.75)' },
                  searchBox: { border: '1px solid #ccc', borderRadius: '8px', fontSize: '12px' },
                  optionContainer: { borderRadius: '8px' },
                }}
              />
            </div>
          </div>

          <div className="small text-muted mb-2 fw-semibold">
            {(tab1.selectedTerritoryL1?.length > 0 || tab1.selectedTerritoryL2?.length > 0) ? 'Selected Territories' : 'All Territories'}
          </div>
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {(tab1.selectedTerritoryL1?.length > 0 || tab1.selectedTerritoryL2?.length > 0) ? (
              // Show selected territories when filtered
              <>
                {tab1.selectedTerritoryL1?.map((territory) => (
                  <div key={territory.id} className="border-bottom py-1 small">
                    <span className="badge bg-primary me-1">L1</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {territory.name}
                  </div>
                ))}
                {tab1.selectedTerritoryL2?.map((territory) => (
                  <div key={territory.id} className="border-bottom py-1 small">
                    <span className="badge bg-secondary me-1">L2</span>
                    <span className="badge bg-success me-1">Selected</span>
                    {territory.name}
                  </div>
                ))}
              </>
            ) : (
              // Show all territories by default
              <>
                <div className="small fw-semibold text-primary mb-1">Level 1 Territories:</div>
                {(tab1.territoryL1Options || []).map((territory) => (
                  <div key={territory.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-primary me-1">L1</span>
                    {territory.name}
                  </div>
                ))}
                <div className="small fw-semibold text-secondary mb-1 mt-2">Level 2 Territories:</div>
                {(tab1.territoryL2Options || []).map((territory) => (
                  <div key={territory.id} className="border-bottom py-1 small text-muted">
                    <span className="badge bg-secondary me-1">L2</span>
                    {territory.name}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>

  </div>
)}


     {view === 'combination' && (
            <div>
              <div className="mb-4">
                <div className="d-flex align-items-center mb-3">
                  <button
                    className={`btn btn-sm ${step === 1 ? 'btn-primary' : 'btn-outline-primary'} rounded-pill me-2`}
                    onClick={() => setStep(1)}
                  >
                    Step 1: Select Licensor
                  </button>
                  <ChevronRight size={16} className="text-muted me-2" />
                  <button
  className={`btn btn-sm ${
    step === 2 ? 'btn-primary' : 'btn-outline-primary'
  } rounded-pill me-2`}
  onClick={() => {
    if (selectedLicensor) {
      setStep(2);
      setSelectedProperties([]);
    }
  }}
  disabled={!selectedLicensor}
>
  Step 2: Select Properties
</button>

                  <ChevronRight size={16} className="text-muted me-2" />
                <button
  className={`btn btn-sm ${
    step === 3 ? 'btn-primary' : 'btn-outline-primary'
  } rounded-pill`}
  onClick={() => {
    if (selectedProperties.length > 0) {
      setStep(3);
      setCombinationFilters({
        productL1: 'All',
        productL2: 'All',
        productL3: 'All',
        channelL1: 'All',
        channelL2: 'All',
        channelL3: 'All',
        territoryL1: 'All',
        territoryL2: 'All',
      });
      setCombinationSearch('');
      setCurrentPage(1);
    }
  }}
  disabled={selectedProperties.length === 0}
>

                    Step 3: All Valid Combinations
                  </button>
                </div>
              </div>

              {step === 1 && (
                <div className="card shadow-sm">
                  <div className="card-body">
                    <h4 className="mb-4 fw-bold">Step 1: Select a Licensor</h4>
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text bg-white">
                          <Search size={16} />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search licensors..."
                          value={licensorFilter}
                          onChange={(e) => setLicensorFilter(e.target.value)}
                        />
                      </div>
                    </div>
                   <div class="small text-muted mb-1 fw-bold">Licensor</div>
                    <div>
                      {filteredLicensors.length===0 ? "No Licensor Found " : ""}
                      {filteredLicensors.map((licensor) => (
                        <div
                          key={licensor.id}
                          className="border rounded p-3 mb-2 cursor-pointer hover:bg-light"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setSelectedLicensor(licensor);
                            setSelectedProperties([]);
                            setStep(2);
                          }}
                        >
                          <div className="fw-bold">{licensor.name}</div>
                          <div className="text-muted small">{licensor.property_count} properties</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {step === 2 && selectedLicensor && (
                <div className="card shadow-sm">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="mb-0 fw-bold">Step 2: Select Properties</h4>
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                          setSelectedLicensor(null);
                          setSelectedProperties([]);
                          setStep(1);
                        }}
                      >
                        Change Licensor
                      </button>
                    </div>
                    <div className="bg-light p-3 rounded mb-4">
                      <div className="small text-muted mb-1">Selected Licensor:</div>
                      <div className="fw-bold">{selectedLicensor.name}</div>
                      <div className="small text-muted d-none">{licensorProperties.length} available properties</div>
                          <div className="small text-muted">
                                {selectedProperties.length} of {licensorProperties.length} properties selected
                                </div>
                    </div>
                    
                    {/* Add search for properties */}
<div className="mb-3">
  <div className="d-flex align-items-center gap-2">
    <div className="input-group flex-grow-1" style={{width:"80%"}}>
      <span className="input-group-text bg-white">
        <Search size={16} />
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Search properties..."
        value={propertyFilter}
        
        onChange={(e) => setPropertyFilter(e.target.value)}
      />
    </div>

    <button
      className="btn btn-primary"
      disabled={selectedProperties.length === 0}
      onClick={async () => {
        setLoading(true);
        try {
          setTableData({});
          const fileName = selectedLicensor?.id || selectedLicensor?.name;
          await getDataExplorerDetail({
            licensor: fileName,
            propertyType: selectedProperties,
          });
          setStep(3);
          setCombinationFilters({
                            productL1: 'All',
                            productL2: 'All',
                            productL3: 'All',
                            channelL1: 'All',
                            channelL2: 'All',
                            channelL3: 'All',
                            territoryL1: 'All',
                            territoryL2: 'All',
                          });
                          setCombinationSearch('');
                          setCurrentPage(1);
        } catch (error) {
          console.error("Error fetching combination data:", error);
          trackError(error);
        } finally {
          setLoading(false);
        }
      }}
    >
      View Combinations
    </button>
  </div>
</div>


      <div>
  {/* Select / Deselect buttons */}
  <div className="d-flex align-items-center gap-2 mb-2">
    <button
      className="btn btn-outline-primary btn-sm"
      onClick={() => {
        const filtered = licensorProperties
          .filter(property =>
            property.name.toLowerCase().includes(propertyFilter.toLowerCase())
          )
          .map(p => p.name);
        setSelectedProperties(prev => Array.from(new Set([...prev, ...filtered])));
      }}
    >
      Select All
    </button>

    <button
      className="btn btn-outline-primary btn-sm"
      onClick={() => {
        const filtered = licensorProperties
          .filter(property =>
            property.name.toLowerCase().includes(propertyFilter.toLowerCase())
          )
          .map(p => p.name);
        setSelectedProperties(prev => prev.filter(name => !filtered.includes(name)));
      }}
    >
      Deselect All
    </button>
  </div>

  {/* Scrollable property list */}
  <div className="row g-3 mb-4" style={{ maxHeight: '400px', overflowY: 'auto' }}>
    {licensorProperties
      .filter(property =>
        property.name.toLowerCase().includes(propertyFilter.toLowerCase())
      )
      .map((property) => (
        <div key={property.id} className="col-md-6">
          <div
            className={`rounded p-1 cursor-pointer ${
              selectedProperties.includes(property.name)
                ? 'border-primary bg-light'
                : ''
            }`}
            style={{ cursor: 'pointer' }}
            onClick={() => toggleProperty(property.name)}
          >
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={selectedProperties.includes(property.name)}
                onChange={() => toggleProperty(property.name)}
                onClick={(e) => e.stopPropagation()}
              />
              <label className="form-check-label text-muted small">
                {property.name}
              </label>
            </div>
          </div>
        </div>
      ))}
  </div>
</div>



                              
                              
                              </div>
                            </div>
                            )}

                            {step === 3 && selectedProperties.length > 0 && (
                            <div className="card shadow-sm">
                              <div className="card-body">
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                <h4 className="mb-1 fw-bold">Step 3: All Valid Combinations</h4>
                                <div className="small text-muted d-none">
                                  Licensor: <span className="fw-semibold">{selectedLicensor?.name}</span> |
                                  Properties: <span className="fw-semibold">{selectedProperties.join(', ')}</span> |
                                  Total Combinations: <span className="fw-semibold">{getRelevantCombinations().length}</span> |
                                  Filtered: <span className="fw-semibold">{filteredCombinations.length}</span>
                                </div>
                                </div>
                                <div style={{ display: "flex", gap: "8px", marginTop: "25px" }}>
  <button
    className="btn btn-outline-primary btn-sm"
    onClick={() => {
      setCombinationFilters({
        productL1: 'All',
        productL2: 'All',
        productL3: 'All',
        channelL1: 'All',
        channelL2: 'All',
        channelL3: 'All',
        territoryL1: 'All',
        territoryL2: 'All',
      });
      setCombinationSearch('');
      setCurrentPage(1);
    }}
  >
    Clear All
  </button>

  <button
    className="btn btn-outline-primary btn-sm"
    onClick={() => {
      const rows = filteredCombinations.map(c => ({
        Property: c.property,
        "Product L1": c.product_l1,
        "Product L2": c.product_l2,
        "Product L3": c.product_l3 || '',
        "Channel L1": c.channel_l1,
        "Channel L2": c.channel_l2,
        "Channel L3": c.channel_l3 || '',
        "Territory L1": c.territory_l1,
        "Territory L2": c.territory_l2,
        "Exceptions": c.exceptions
      }));

      if (!rows.length) {
        alert('No data to export');
        return;
      }

      const header = Object.keys(rows[0]);
      const escapeCell = (v) => {
        if (v == null) return '';
        return String(v).replace(/\t/g, ' ').replace(/\r?\n/g, ' ');
      };
      const tsv = '\uFEFF' + header.join('\t') + '\n' +
        rows.map(r => header.map(h => escapeCell(r[h])).join('\t')).join('\n');

      const blob = new Blob([tsv], { type: 'application/vnd.ms-excel' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const nameBase = (selectedLicensor?.name || 'combinations').replace(/\s+/g, '_');
      a.href = url;
      a.download = `${nameBase}_${new Date().toISOString().slice(0, 10)}.xls`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    }}
  >
    Export XLS
  </button>
</div>


                      
                              </div>

                    {/* Show loading state while fetching combinations */}
                    {loading && (
                      <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading combinations...</span>
                        </div>
                        <div className="mt-2 text-muted">Fetching combination data...</div>
                      </div>
                    )}

                    {!loading && (
                      <>
                        {/* Existing filters section */}
                        <div className="mb-3">
                          <div className="fw-semibold mb-2 d-flex align-items-center">
                            <span className="me-2">🔍</span> Filters
                          </div>
                          <div className="row g-2 mb-3">
                            <div className="col-md-3">
                              <label className="form-label small">Product L1</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.productL1}
                                onChange={(e) => handleProductL1Change(e.target.value)}
                              >
                                {uniqueCombinationValues.productL1.map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-3">
                              <label className="form-label small">Product L2</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.productL2}
                                onChange={(e) => handleProductL2Change(e.target.value)}
                              >
                                {getFilteredProductL2Options().map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-3">
                              <label className="form-label small">Product L3</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.productL3}
                                onChange={(e) => setCombinationFilters({...combinationFilters, productL3: e.target.value})}
                              >
                                {getFilteredProductL3Options().map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-3">
                              <label className="form-label small">Channel L1</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.channelL1}
                                onChange={(e) => handleChannelL1Change(e.target.value)}
                              >
                                {uniqueCombinationValues.channelL1.map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="row g-2 mb-3">
                            <div className="col-md-3">
                              <label className="form-label small">Channel L2</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.channelL2}
                                onChange={(e) => handleChannelL2Change(e.target.value)}
                              >
                                {getFilteredChannelL2Options().map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-3">
                              <label className="form-label small">Channel L3</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.channelL3}
                                onChange={(e) => setCombinationFilters({...combinationFilters, channelL3: e.target.value})}
                              >
                                {getFilteredChannelL3Options().map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-3">
                              <label className="form-label small">Territory L1</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.territoryL1}
                                onChange={(e) => handleTerritoryL1Change(e.target.value)}
                              >
                                {uniqueCombinationValues.territoryL1.map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                            <div className="col-md-3">
                              <label className="form-label small">Territory L2</label>
                              <select
                                className="form-select form-select-sm"
                                value={combinationFilters.territoryL2}
                                onChange={(e) => setCombinationFilters({...combinationFilters, territoryL2: e.target.value})}
                              >
                                {getFilteredTerritoryL2Options().map(v => (
                                  <option key={v} value={v}>{v}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="input-group">
                            <span className="input-group-text bg-white">
                              <Search size={16} />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search combinations..."
                              value={combinationSearch}
                              onChange={(e) => {
                                setCombinationSearch(e.target.value);
                                setCurrentPage(1);
                              }}
                            />
                            <button className="btn btn-primary">{filteredCombinations.length} combinations</button>

                             {totalPages > 1 && (
                          <div className="d-flex justify-content-between align-items-center mt-1 px-5">
                            {/* Range text (Gmail style) */}
                            <div className="text-muted small">
                              {((currentPage - 1) * rowsPerPage) + 1}–
                              {Math.min(currentPage * rowsPerPage, filteredCombinations.length)} of{" "}
                              {filteredCombinations.length}
                            </div>

                            {/* Gmail-like navigation with Lucide icons */}
                            <div className="d-flex align-items-center">
                              <button
                                className="btn btn-sm btn-light border-0"
                                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                disabled={currentPage === 1}
                                style={{ opacity: currentPage === 1 ? 0.4 : 1 }}
                                title="Previous"
                              >
                                <ChevronLeft size={20} />
                              </button>

                              <button
                                className="btn btn-sm btn-light border-0 ms-2"
                                onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                disabled={currentPage === totalPages}
                                style={{ opacity: currentPage === totalPages ? 0.4 : 1 }}
                                title="Next"
                              >
                                <ChevronRight size={20} />
                              </button>
                            </div>
                          </div>
                        )}

                          </div>
                         

                        </div>

                        {/* Enhanced table with better column headers */}
                        <div className="table-responsive">
                          <table className="table table-sm table-hover">
                            <thead className="table-light">
                              <tr>
                                <th className="small">Property</th>
                                <th className="small">Product L1</th>
                                <th className="small">Product L2</th>
                                <th className="small">Product L3</th>
                                <th className="small">Channel L1</th>
                                <th className="small">Channel L2</th>
                                <th className="small">Channel L3</th>
                                <th className="small">Territory L1</th>
                                <th className="small">Territory L2</th>
                                <th className="small">Exception</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedCombinations.length > 0 ? (
                                paginatedCombinations.map((combo) => (
                                  <tr key={combo.id} className="small">
                                    <td className="fw-semibold text-primary">{combo.property}</td>
                                    <td>{combo.product_l1}</td>
                                    <td>{combo.product_l2}</td>
                                    <td >{combo.product_l3}</td>
                                    <td>{combo.channel_l1}</td>
                                    <td>{combo.channel_l2}</td>
                                    <td >{combo.channel_l3 || 'N/A'}</td>
                                    <td>{combo.territory_l1}</td>
                                    <td>{combo.territory_l2}</td>
                                    <td className="text-center align-middle">
                                      {/* Icon button - click to open modal with exceptions */}
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={(e) => { e.stopPropagation(); openExceptionsModal(combo.exceptions); }}
                                        title="View exception"
                                      >
                                        ⚠️
                                      </button>
                                    </td>
  
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="10" className="text-center text-muted py-4">
                                    {tableData && tableData.data && tableData.data.length > 0 ? 'No combinations match your filters' : 'No combination data available'}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                       
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          )} </>)}

  {showExceptionsModal && (
    <>
      <div className="modal d-block" tabIndex="-1" role="dialog" onClick={closeExceptionsModal}>
        <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Exception</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={closeExceptionsModal}></button>
            </div>
            <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto', padding: '1rem' }}>
              <pre className="small" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {modalExceptions || 'No exceptions available'}
              </pre>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={closeExceptionsModal}>Close</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  )}

        </div>
      </div>
    </div>
  );
}